import { observer } from 'mobx-react-lite';

import PageLayout from '../../../shared/components/PageLayout';
import StripeElementsProvider from '../../../shared/components/StripeElementsProvider';
import { getCurrencyForAreaUnit } from '../../../shared/helpers/functions/currency';
import rootStore from '../../features/rootStore/RootStore';

const CheckoutPageLayout = observer(() => {
  const { areaUnitStore } = rootStore;
  const { areaUnit } = areaUnitStore;
  const currency = getCurrencyForAreaUnit(areaUnit);

  return (
    <StripeElementsProvider currency={currency}>
      <PageLayout />
    </StripeElementsProvider>
  );
});

export default CheckoutPageLayout;
